import type { HouseholdState } from '../types';
import { seedState } from './seed';

const KEY = 'roka-household-food-demo-v1';

export function loadState(): HouseholdState {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) as HouseholdState : structuredClone(seedState);
  } catch {
    return structuredClone(seedState);
  }
}

export function saveState(state: HouseholdState) {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function resetState() {
  localStorage.removeItem(KEY);
}
